import { Link } from 'react-router-dom';
import { standardData } from '@/mocks/mosstalk';
import ConsultationForm from '@/components/ConsultationForm';

function StandardPage() {
  return (
    <>
      {/* Banner */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <div className="absolute inset-0 bg-primary-950/85 z-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50 z-[1]" />
        <div className="absolute inset-0 z-[1]">
          <img src="/images/banner-bg.jpg" alt="MossTalk 标准款" className="w-full h-full object-cover object-top opacity-35" />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <div className="w-full max-w-3xl mx-auto">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium text-white/80 border border-white/25 rounded-full backdrop-blur-sm">{standardData.banner.tag}</span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-4">{standardData.banner.title}</h1>
            <p className="text-lg md:text-2xl text-white/80 font-light">{standardData.banner.subtitle}</p>
          </div>
        </div>
      </section>

      {/* 产品标题区 — 参考 eningqu 大标题风格 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-4">AI 大模型指环翻译机</h2>
          <p className="text-lg md:text-xl text-foreground-500 mb-10">您的随身翻译官 · 140+ 语种全球畅聊</p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                <i className="ri-translate text-base"></i>
              </div>
              <span>140+ 语种</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-50 text-accent-500">
                <i className="ri-camera-line text-base"></i>
              </div>
              <span>拍照翻译</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500">
                <i className="ri-wifi-off-line text-base"></i>
              </div>
              <span>10种离线</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                <i className="ri-vip-crown-line text-base"></i>
              </div>
              <span>永久免费</span>
            </div>
          </div>
        </div>
      </section>

      {/* 产品展示 & 规格 — 参考 eningqu 双列规格 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">产品展示</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-3">根据具体需求进行定制</h2>
            <p className="text-sm text-foreground-500">小巧便携 · 大模型翻译 · 超长待机</p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/5 rounded-3xl" />
              <img src="/images/mosstalk/standard/2-overview.jpg" alt="产品展示" className="relative z-10 w-full rounded-2xl" />
            </div>
            <div className="grid grid-cols-2 gap-x-6 gap-y-5">
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">产品型号</div>
                <div className="text-xs text-foreground-500">MossTalk Pro T1 / XY-T02</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">产品直径</div>
                <div className="text-xs text-foreground-500">56.5 mm</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">产品净重</div>
                <div className="text-xs text-foreground-500">35 g</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">电池容量</div>
                <div className="text-xs text-foreground-500">60 mAh</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">充电时间</div>
                <div className="text-xs text-foreground-500">约 30 分钟</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">待机时间</div>
                <div className="text-xs text-foreground-500">约 30 天</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">蓝牙版本</div>
                <div className="text-xs text-foreground-500">Bluetooth 4.2 BLE</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">适配系统</div>
                <div className="text-xs text-foreground-500">Android 8.0+ / iOS 13+</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">在线语种</div>
                <div className="text-xs text-foreground-500">140+ 语种</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">离线语种</div>
                <div className="text-xs text-foreground-500">10 种</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">颜色选项</div>
                <div className="text-xs text-foreground-500">曜石黑 / 玫瑰金 / 星耀银</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-background-200">
                <div className="text-sm font-bold text-foreground-900 mb-1">连续翻译</div>
                <div className="text-xs text-foreground-500">约 6 小时</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 特色功能 — 参考 eningqu 图标网格 (2行 × 3列) */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">特色功能</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-3">{standardData.advantages.title}</h2>
            <p className="text-sm md:text-base text-foreground-500">{standardData.advantages.subtitle}</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 md:gap-6">
            {standardData.advantages.items.map((a, idx) => (
              <div key={idx} className="flex flex-col items-center text-center p-5 md:p-6 bg-white rounded-2xl border border-background-200 hover:border-primary-200 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-3">
                  <i className={`${a.icon} text-xl`}></i>
                </div>
                <h4 className="text-sm font-bold text-foreground-900 mb-1.5">{a.name}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 核心功能 — 交错图文 (前4个) */}
      <section className="bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">核心功能</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{standardData.features.title}</h2>
          </div>

          {/* Feature 1: 文本翻译 — 左文右图 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="lg:pr-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className="ri-file-text-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{standardData.features.items[0].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{standardData.features.items[0].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">140+ 语种</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">双向翻译</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">复制分享</span>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl">
              <img src={standardData.features.items[0].imageSrc} alt={standardData.features.items[0].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>

          {/* Feature 2: 语音翻译 — 左图右文 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="order-2 lg:order-1 overflow-hidden rounded-2xl">
              <img src={standardData.features.items[1].imageSrc} alt={standardData.features.items[1].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="order-1 lg:order-2 lg:pl-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-4">
                <i className="ri-mic-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{standardData.features.items[1].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{standardData.features.items[1].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">一键录音</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">秒级响应</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">连续对话</span>
              </div>
            </div>
          </div>

          {/* Feature 3: 拍照翻译 — 左文右图 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20 md:mb-28">
            <div className="lg:pr-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className="ri-camera-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{standardData.features.items[2].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{standardData.features.items[2].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">OCR 识别</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">竖排古文</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">手写体</span>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl">
              <img src={standardData.features.items[2].imageSrc} alt={standardData.features.items[2].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>

          {/* Feature 4: 实时对话翻译 — 左图右文 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="order-2 lg:order-1 overflow-hidden rounded-2xl">
              <img src={standardData.features.items[3].imageSrc} alt={standardData.features.items[3].name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="order-1 lg:order-2 lg:pl-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-4">
                <i className="ri-chat-1-line text-xl"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{standardData.features.items[3].name}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{standardData.features.items[3].desc}</p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">自动语种识别</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">分屏显示</span>
                <span className="px-3 py-1 bg-background-100 text-foreground-600 rounded-full text-xs">自然对话</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 其余功能 — 2×2 卡片网格 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300">
              <div className="h-44 md:h-52 overflow-hidden">
                <img src="/images/mosstalk/standard/7-simultaneous.jpg" alt="基础同传" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                    <i className="ri-headphone-line text-base"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">基础同传</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">支持同声传译模式，可搭配蓝牙耳机实现私密收听翻译内容。</p>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300">
              <div className="h-44 md:h-52 overflow-hidden">
                <img src="/images/mosstalk/standard/8-subtitle.jpg" alt="通话双语字幕" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-50 text-secondary-500">
                    <i className="ri-live-line text-base"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">通话双语字幕</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">音视频通话时自动生成双语字幕，跨国视频聊天、远程会议无障碍沟通。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 应用场景 — 参考 eningqu 图片卡片 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">应用场景</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">适用场景</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/standard/9-travel.jpg" alt="出境旅游" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-flight-takeoff-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">出境旅游</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">餐厅点餐、酒店入住、景点问路、购物砍价，140+语种实时翻译无障碍</p>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/standard/10-daily.jpg" alt="日常外语交流" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-chat-3-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">日常外语交流</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">与外国朋友聊天、参加语言交换活动，对话翻译自然流畅</p>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/standard/11-learning.jpg" alt="语言自学" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-book-open-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">语言自学</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">外语阅读辅助、单词查询、发音学习，随身私人口语教练</p>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
              <div className="h-36 md:h-44 overflow-hidden">
                <img src="/images/mosstalk/standard/12-shopping.jpg" alt="海外购物" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                    <i className="ri-shopping-bag-3-line text-sm"></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900">海外购物</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">商品标签翻译、与店员沟通、退税咨询，海外剁手零障碍</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 技术参数 — 表格 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{standardData.specs.title}</h2>
          </div>
          <div className="bg-white rounded-2xl border border-background-200 overflow-hidden">
            <div className="divide-y divide-background-100">
              {standardData.specs.rows.map((row, idx) => (
                <div key={idx} className={`flex flex-col sm:flex-row py-4 px-6 md:px-8 ${idx % 2 === 0 ? 'bg-background-50/50' : ''}`}>
                  <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider w-full sm:w-40 flex-shrink-0 mb-1 sm:mb-0">{row.label}</span>
                  <span className="text-sm text-foreground-800">{row.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 相关产品 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">相关产品推荐</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <Link to="/mosstalk/business" className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="h-44 overflow-hidden">
                <img src="/images/recommendation/mosstalk-business.jpg" alt="MossTalk 商务款翻译机" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <h4 className="text-sm font-bold text-foreground-900 mb-1">MossTalk 商务款翻译机</h4>
                <p className="text-xs text-foreground-500">标准款全功能 + AI会议总结 + 思维导图</p>
              </div>
            </Link>
            <Link to="/mosstalk/earbuds" className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="h-44 overflow-hidden">
                <img src="/images/recommendation/mosstalk-earbuds.jpg" alt="MossTalk 翻译耳机" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <h4 className="text-sm font-bold text-foreground-900 mb-1">MossTalk 翻译耳机</h4>
                <p className="text-xs text-foreground-500">100dB主动降噪，通话翻译一体</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-primary-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">对 MossTalk 标准款感兴趣？</h2>
          <p className="text-white/75 text-sm md:text-base mb-8">立即咨询产品详情、获取报价或访问产品详情页了解更多</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={standardData.cta.primary.href} className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-customer-service-2-line mr-2"></i>{standardData.cta.primary.text}</a>
            <Link to={standardData.cta.secondary.href} className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-file-download-line mr-2"></i>{standardData.cta.secondary.text}</Link>
            <a href={standardData.cta.tertiary.href} target="_blank" rel="nofollow noopener" className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-external-link-line mr-2"></i>{standardData.cta.tertiary.text}</a>
            <a href={standardData.cta.jd.href} target="_blank" rel="noopener noreferrer" className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-shopping-bag-line mr-2"></i>{standardData.cta.jd.text}</a>
          </div>
        </div>
      </section>

      {/* 咨询表单 */}
      <ConsultationForm badge="商务咨询" title="在线咨询" subtitle="填写以下信息，我们的商务团队将在24小时内与您联系" />
    </>
  );
}

export default StandardPage;